import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  root: {
    padding: '5px',
    color: 'black',
  },
});
